import { render, staticRenderFns } from "./userviewreport.vue?vue&type=template&id=60321e64&scoped=true&"
import script from "./userviewreport.vue?vue&type=script&lang=js&"
export * from "./userviewreport.vue?vue&type=script&lang=js&"
import style0 from "./userviewreport.vue?vue&type=style&index=0&id=60321e64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60321e64",
  null
  
)

export default component.exports